// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__B5Xfi","input":"style_input__gA3Os"};